export default __webpack_public_path__ + "static/media/sparck-profile-banner.fc94e67a.png";